<template>
  <section
    class="new-related-collection container px20"
    v-if="getCurrentRelatedProducts.length"
  >
    <products-slider
      :title="heading"
      :products="getCurrentRelatedProducts"
      :config="configSlider"
      :isBadge="true"
      :isH4="true"
      :categoryProps="categoryProps"
      v-if="getCurrentRelatedProducts && getCurrentRelatedProducts.length"
      id="related"
    />
  </section>
</template>

<script>
import ProductListing from 'theme/components/core/ProductListing'
import ProductsSlider from 'theme/components/core/ProductsSlider';
import { mapGetters } from 'vuex'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'
import i18n from '@vue-storefront/i18n'
import config from 'config'

export default {
  name: 'Related',
  data () {
    return {
      config,
      configSlider: {
        perPageCustom: [
          [1, 1],
          [375, 2],
          [567, 2],
          [768, 2],
          [992, 3],
          [1200, 3],
          [1400, 4]
        ],
        paginationEnabled: false,
        scrollPerPage: false,
        autoplayTimeout: 5000,
        speed: 1000,
        navigationEnabled: true
      }
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: false,
      default: i18n.t('Similar products')
    },
    related: {
      type: String,
      required: false,
      default: 'sku'
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    } 
  },
  components: {
    ProductListing,
    ProductsSlider
  },
  beforeMount () {
    this.$bus.$on('product-after-load', this.refreshList)

    if (config.usePriceTiers) {
      this.$bus.$on('user-after-loggedin', this.refreshList)
      this.$bus.$on('user-after-logout', this.refreshList)
    }

    this.refreshList()
  },
  beforeDestroy () {
    if (config.usePriceTiers) {
      this.$bus.$off('user-after-loggedin', this.refreshList)
      this.$bus.$off('user-after-logout', this.refreshList)
    }
  },
  destroyed () {
    this.$bus.$off('product-after-load', this.refreshList)
  },
  methods: {
    async refreshList () {
      let sku = this.productLinks ? this.productLinks
        .filter(pl => pl.link_type === this.type)
        .map(pl => pl.linked_product_sku) : null

      let key = this.related
      if (sku === null || (sku.length === 0)) {
        sku = this.getCurrentProduct.category_ids
        key = this.related !== 'sku' ? this.related : 'category_ids'
      }

      if (this.related !== 'sku') {
        sku = this.getCurrentProduct[this.related]
      }
      let relatedProductsQuery = prepareRelatedQuery(key, sku)

      if (this.related === 'custom_3') {
        const { items } = await this.$store.dispatch('product/list', {
          query: relatedProductsQuery,
          size: 10,
          prefetchGroupProducts: false,
          updateState: false
        });
        if (!!sku && items.length) {
          const availableItems = items.filter(p => !p.is_hidden)
          this.$store.dispatch('product/related', {
            key: this.type,
            items: availableItems
          })
          this.$forceUpdate()
        }
      } else {
        const { items } = await this.$store.dispatch('product/findProducts', {
          query: relatedProductsQuery,
          size: 25,
          options: {
            populateRequestCacheTags: false,
            prefetchGroupProducts: false
          }
        })

        if (items.length) {
          const availableItems = items.filter(p => !p.is_hidden)      
          this.$store.dispatch('product/related', {
            key: this.type,
            items: availableItems
          })
          this.$forceUpdate()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getProductRelated: 'product/getProductRelated',
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    getCurrentRelatedProducts () {
      return this.getProductRelated[this.type] || []
    },
    productLinks () {
      return this.getCurrentProduct.product_links
    }
  }
}
</script>

<style lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/variables/grid';

.new-related-collection {
  margin-bottom: 30px;
  margin-top: 15px;
  padding: 0 $gutter-size $gutter-size;
}

</style>
